/**
 * @jesus-central-church/youtube
 *
 * YouTube integration package for RSS feeds and live stream detection
 */

// =============================================================================
// RSS Exports (backward compatible with @jesus-central-church/youtube-client)
// =============================================================================

export { fetchChannelRssFeed } from "./rss/api";
export type { RssVideo } from "./rss/types";

// =============================================================================
// Live Stream Detection Exports
// =============================================================================

export { checkChannelLiveStatus } from "./live/api";
export { useYouTubeLive } from "./live/hooks/use-youtube-live";
export { createLiveRouteHandler } from "./live/handlers/route-handler";

export type {
  LiveStreamInfo,
  LiveStreamResponse,
  UseYouTubeLiveOptions,
  UseYouTubeLiveResult,
  LiveRouteHandlerConfig,
} from "./live/types";

// =============================================================================
// Constants (for advanced usage)
// =============================================================================

export {
  YOUTUBE_API_BASE_URL,
  YOUTUBE_WATCH_URL as YOUTUBE_LIVE_WATCH_URL,
  CACHE_TTL_LIVE,
  CACHE_TTL_NOT_LIVE,
  DEFAULT_POLLING_INTERVAL,
  DEFAULT_API_ENDPOINT,
  DEFAULT_CHANNEL_ID,
} from "./live/constants";

export {
  YOUTUBE_RSS_BASE_URL,
  YOUTUBE_WATCH_URL,
  YOUTUBE_THUMBNAIL_URL,
  CACHE_REVALIDATE_TIME,
  THUMBNAIL_QUALITY,
  DEFAULT_THUMBNAIL_QUALITY,
} from "./rss/constants";
